module.exports = __webpack_public_path__ + "img/platform-transactional-32.a00615c4.svg";